import { getAnswer, postAnswer, assignHomework } from "@/api/api";
import studentMixin from "@/mixins/studentMixin";
import Editor from "@/components/Utils/Editor";
import CommentGroup from "@/components/Lessons/Lesson/components/CommentGroup.vue";
import Qualification from "@/components/Utils/Qualification.vue";
import StudentNote from "@/components/Utils/StudentNote.vue";

export default {
  components: {
    appEditor: Editor,
    appCommentGroup: CommentGroup,
    appQualification: Qualification,
    appStudentNote: StudentNote,
  },
  props: {
    data: Object,
  },
  mixins: [studentMixin],
  data() {
    return {
      answers: [],
      audios: [],
      qualification: {},
      loading: true,
      loadingAssign: false,
      finished: false,
      commentDialog: false,
    };
  },
  computed: {
    stepType() {
      if (this.$route.name === "practice") {
        return "PRACTICE_HOMEWORK";
      }
      return "TEACH_HOMEWORK";
    },
    disabled() {
      return this.data.students.findIndex((item) => item.uuid === this.student.uuid) !== -1;
    },
    answered() {
      return !!(this.answers.length && this.answers[0].uuid);
    },
  },
  methods: {
    onReset() {
      this.finished = false;
      this.answers = [];
      this.audios = [];
      this.qualification = {};
      this.$refs.commentGroup?.updateComments(this.data.comment_group);
      this.create();
    },
    async save() {
      for (let index = 0; index < this.answers.length; index++) {
        const element = this.answers[index];
        if (!this.answers.uuid) {
          if (this.audios[index].audioBlob) {
            element.audio_file = this.audios[index].audioBlob;
          }
          const response = await postAnswer(element);
          if (response) {
            this.answers.splice(index, 1, response.data);
          }
        }
      }
      this.qualification = await this.qualify();
    },
    async assign(homework) {
      try {
        this.loadingAssign = true;
        await assignHomework({
          homework,
          student: this.student.email,
        });
        this.finished = true;
      } finally {
        this.loadingAssign = false;
      }
    },
    async create() {
      for (let index = 0; index < this.data.question_group.questions.length; index++) {
        const element = this.data.question_group.questions[index];

        const response = await getAnswer({
          question__uuid: element.uuid,
          student__email: this.student.email,
        });
        this.audios.push({});
        if (response.data.count) {
          this.answers.push(response.data.results[0]);
        } else
          this.answers.push({
            question: element.uuid,
            student: this.student.email,
          });
      }

      this.qualification = await this.fetchQualification(
        this.student.email,
        this.data.question_group.uuid,
      );
      this.loading = false;
    },
  },
  created() {
    this.create();
  },
};
